"use client"

import { useEffect, useRef } from "react"

export function NoiseOverlay() {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext("2d")
    if (!ctx) return

    let animationId: number
    let lastTime = 0
    const fps = 24 // Film-like frame rate for the grain

    const resize = () => {
      // Use a smaller resolution for performance, then scale up
      canvas.width = Math.ceil(window.innerWidth / 2)
      canvas.height = Math.ceil(window.innerHeight / 2)
    }

    const noise = (timestamp: number) => {
      // Throttle to target fps for that film grain look
      if (timestamp - lastTime < 1000 / fps) {
        animationId = requestAnimationFrame(noise)
        return
      }
      lastTime = timestamp

      const imageData = ctx.createImageData(canvas.width, canvas.height)
      const data = imageData.data

      for (let i = 0; i < data.length; i += 4) {
        // Random value between 0-50 for subtle dark grain
        const value = Math.random() * 50
        data[i] = value     // R
        data[i + 1] = value // G
        data[i + 2] = value // B
        data[i + 3] = 255   // Full opacity - we control visibility with CSS
      }

      ctx.putImageData(imageData, 0, 0)
      animationId = requestAnimationFrame(noise)
    }

    resize()
    animationId = requestAnimationFrame(noise)
    window.addEventListener("resize", resize)

    return () => {
      window.removeEventListener("resize", resize)
      cancelAnimationFrame(animationId)
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      className="pointer-events-none fixed inset-0 z-40 opacity-0 dark:opacity-[0.12]"
      style={{
        width: "100vw",
        height: "100vh",
      }}
      aria-hidden="true"
    />
  )
}
